import { Card, CardDesc, CardEmoji, CardName, CardRegion } from "./style";

export const AttractionCardComponent = ({ attraction, language }) => {
  return (
    <Card>
      <CardEmoji>{attraction.emoji}</CardEmoji>
      <CardName>{attraction.name[language]}</CardName>
      <CardDesc>{attraction.desc[language]}</CardDesc>
      <CardRegion>📍 {attraction.region[language]}</CardRegion>
    </Card>
  );
};
